var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectTableDialog',{attrs:{"title":"引用采购合同创建供应商发货指令","searchColumns":_vm.searchColumns,"columnList":_vm.columnList,"defaultVisible":_vm.defaultVisible,"API":_vm.listOrderAPI,"extraData":{
    contractCategory: 'purchase',
    contractStatus: 'ZT03',
    deliveryFlag: '1', //限制类型
    deliverableQuantityStart: 0,
    departmentCode: _vm.userInfo.departmentCode,
    companyCode: _vm.userInfo.companyCode,
  },"propCode":"contractNo","width":"80%"},on:{"close":_vm.close,"dblclickEvent":_vm.dblclickEvent,"confirm":_vm.confirm,"changeQuery":_vm.changeQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }